import { Component, OnInit } from '@angular/core';
import { MessageService, SelectItem } from 'primeng/api';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { CustomerSetImportService } from 'app/services/customer/customer-set-import.service';
import { CustomerClusterService } from 'app/services/customer/customer-cluster.service';
import { FileExport } from 'app/models/import-gift.model';
import * as XLSX from 'xlsx';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';
import { ConfirmationService, FileUpload } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

type AOA = FileExport[];
@Component({
  selector: 'app-customer-set-import-add',
  templateUrl: './customer-set-import-add.component.html',
  styleUrls: ['./customer-set-import-add.component.css']
})
export class CustomerSetImportAddComponent implements OnInit {

  form: FormGroup;
  invalidSubmit: boolean;
  validation: any;
  customerImportField: any;

  fileImport: File = null;
  fileData: AOA;
  fileName: string;

  checkImportRes: any = [];
  importFileRes: any = [];
  fileObs: any;

  clusterHead: SelectItem[] = [];
  clusterOption: SelectItem[] = [];
  clusters = [];

  showCreateCluster: boolean;

  button: boolean;
  returnButton: boolean;
  exampleFileName: string = "ExampleFileImportQuery.csv";

  constructor(
    private message: MessageService,
    private route: Router,
    private customerImportService: CustomerSetImportService,
    private customerClusterService: CustomerClusterService,
    private fb: FormBuilder,
  ) { }


  ngOnInit() {
    this.loadValidation();

    this.customerClusterService.getClusterHeadAllListWithParams([{ key: 'limit', value: '99999' }]).subscribe(
      res => {
        this.clusters = res;
        res.forEach((el) => {
          this.clusterOption.push({ label: `${el.clusterDescription} | ${el.date_start} - ${el.date_end} | ${el.code}`, value: `${el.clusterHeadId}` })
        });
      })
  }

  /**
   * Carica i campi dal metodo getFields del Servizio CustomerSetImportService
   */
  loadValidation() {
    this.customerImportService.getCustomerSetImportFields().subscribe(res => this.customerImportField = res);
    this.customerImportService.getCustomerSetImportExcelFields().subscribe(res => this.validation = res);

    this.form = this.fb.group({
      name: '',
      description: '',
      clusterHeadId: '',
    })
  }


  /**
   * Metodo che controlla il file importato
   * @returns
   */
  // checkImport() {

  //   if (!this.form.valid) {
  //     this.invalidSubmit = true;
  //     return;
  //   }

  //   this.invalidSubmit = false;
  //   this.button = true;

  //   const reader: FileReader = new FileReader();
  //   reader.onload = (e: any) => {

  //     /* read workbook */
  //     const bstr: string = e.target.result;
  //     const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary', cellDates: true });

  //     console.log(wb)
  //     /* grab first sheet */
  //     const wsname: string = wb.SheetNames[0];
  //     const ws: XLSX.WorkSheet = wb.Sheets[wsname];




  //     /* save data */
  //     this.fileData = <AOA>(XLSX.utils.sheet_to_json(ws, { blankrows: true, defval: null }));

  //     const movementsObs: FileExport[] = [];


  //     this.fileData.forEach(row => {
  //       movementsObs.push(row);
  //     });

  //     this.fileObs = movementsObs;

  //     this.customerImportService.checkImportQuery(movementsObs).subscribe(
  //       res => {
  //         this.checkImportRes = res;
  //       });

  //   }

  //   if (this.fileImport != null) {
  //     reader.readAsBinaryString(this.fileImport);
  //   }

  //   this.fileImport = null;
  // }

  onMovementFileUpload(event) {
    if (event.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    console.log(event.files[0]);
    this.fileImport = event.files[0];
    this.fileName = this.fileImport.name;
  }

  /**
   * Metodo che importa il file excel
   * @returns
   */
  importFile(): void {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    let cluster = this.clusters.find( c => c.clusterHeadId === +this.form.get('clusterHeadId').value);

    const customerSetImport = {
      name: this.form.get('name').value,
      description: this.form.get('description').value,
      cluster_head_id: this.form.get('clusterHeadId').value,
      date_end: cluster.date_end
    }

    const data: FormData = new FormData;
    // data.append('fileImport', JSON.stringify(customerSetImport));
    data.append('name' , this.form.get('name').value);
    data.append('description', this.form.get('description').value);
    data.append('cluster_head_id', this.form.get('clusterHeadId').value);
    data.append('date_end', cluster.date_end);
    data.append('fileCsv', this.fileImport, this.fileName);

    console.log(data);

    this.customerImportService.importQuery(data).subscribe(
      () => {
        //Se la chiamata va a buon fine, ritorna nella pagina di /clustering-import
        this.message.add({severity: 'success', summary: 'Success', detail: 'Import Successful'})
        this.route.navigate(["/clustering-import"])

      }
    )


  }

getSizeInMegaBytes(file: File) {
    return file ? file.size / 1000000 : 0;
}

removeFile(file: File, uploader: FileUpload ) {
  const index = uploader.files.indexOf(file);
  uploader.remove(event, index);
  this.fileImport = null;
}

  openCreateCluster() {
    this.showCreateCluster = true;
  }

  closeCreateCluster() {
    this.showCreateCluster = false;
  }

  downloadExampleFile() {
    this.customerImportService.downloadExcel(this.exampleFileName).subscribe(res => {
      FileSaver.saveAs(res, this.exampleFileName);
    })
  }

  reloadClusterHead() {
    this.clusterOption = [];
    this.customerClusterService.getClusterHeadAllListWithParams([{ key: 'limit', value: '99999' }]).subscribe(
      res => {
        this.clusters = res;
        res.forEach((el) => {
          this.clusterOption.push({ label: `${el.clusterDescription} | ${el.date_start} - ${el.date_end} | ${el.code}`, value: `${el.clusterHeadId}` })
        });
      })
    this.closeCreateCluster()
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-set-import/customer-set-import-add/customer-set-import-add.component.ts